import Settings from '@/config/Settings'
import Moment from 'moment'

const cdn = url => {
  // return url
  // return Settings.cdn + url
  return ['roxham.onf.ca', 'roxham.nfb.ca', 'roxham-dev.onf.ca', 'roxham-dev.nfb.ca'].indexOf(window.location.hostname) > -1
  ? Settings.cdn + url
  : url
}

const setToMs = (object, loop) => {
  const sprite = {}
  _.each(object, o => {
    sprite[o.name] = [
      Moment.duration('00:' + o.start).asMilliseconds(),
      Moment.duration('00:' + o.duration).asMilliseconds(),
      loop
    ]
  })
  return sprite
}


export { cdn, setToMs }



// WEBPACK FOOTER //
// ./src/commons/js/Utils.js